import { useState } from "react";
import { format } from "date-fns";
import { id as idLocale } from "date-fns/locale";
import { CalendarDays } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";

const parse = (s) => {
  if (!s) return undefined;
  const [y, m, d] = s.slice(0, 10).split("-").map(Number);
  return new Date(y, m - 1, d);
};

export default function DatePicker({ value, onChange, testid, today, minDate, placeholder = "Pilih tanggal" }) {
  const [open, setOpen] = useState(false);
  const date = parse(value);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testid}
          className="flex h-9 w-full items-center gap-2 rounded-xl border border-[#E7E7EA] bg-white px-3.5 text-[0.8125rem] shadow-[0_1px_2px_rgba(16,24,40,0.04)] hover:bg-zinc-50 transition-colors text-left whitespace-nowrap overflow-hidden">
          <CalendarDays className="h-4 w-4 text-slate-400" />
          <span className={date ? "text-slate-900" : "text-slate-400"}>{date ? format(date, "d MMMM yyyy", { locale: idLocale }) : placeholder}</span>
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 rounded-[24px]" align="start">
        <Calendar mode="single" locale={idLocale} weekStartsOn={1} selected={date} defaultMonth={date || parse(today)}
          today={parse(today)} initialFocus disabled={minDate ? { before: parse(minDate) } : undefined}
          onSelect={(d) => { if (d) { onChange(format(d, "yyyy-MM-dd")); setOpen(false); } }} />
        {today && !(minDate && minDate > today) && (
          <div className="border-t border-slate-100 px-3 py-2 flex justify-between items-center">
            <span className="text-[11px] text-slate-400">Hari ini (sistem): {format(parse(today), "d MMM yyyy", { locale: idLocale })}</span>
            <button type="button" className="text-xs font-semibold text-blue-600 hover:underline" data-testid={`${testid}-today`}
              onClick={() => { onChange(today); setOpen(false); }}>Hari ini</button>
          </div>
        )}
      </PopoverContent>
    </Popover>
  );
}
